import type { FC } from 'react';
import styled from 'styled-components';
import React from 'react';
import { FrostyBadge } from './FrostyBadge';
import { FuelType } from '../../graphql/types';
import { useUniversalState } from '../context/UniversalStateContext';

type FrostyBadgeType = 'read-only' | 'encourage' | 'markAsNew';
interface BadgesProps {
  fuelTypes: FuelType[];
  markAsNew?: boolean;
  className?: string;
  variantContext?: 'cargroup' | 'carline';
}

export const Badges: FC<BadgesProps> = ({ fuelTypes, markAsNew, className, variantContext }) => {
  const badges: {
    id: string;
    text: string;
    type?: FrostyBadgeType;
    icon?: 'charging';
    variantContext?: 'cargroup' | 'carline';
  }[] = [];
  const { translations } = useUniversalState();

  const hasPetrol = fuelTypes.includes(FuelType.Petrol);
  const hasDiesel = fuelTypes.includes(FuelType.Diesel);
  const hasElectrical = fuelTypes.includes(FuelType.Electrical);
  const hasHybrid = fuelTypes.includes(FuelType.Hybrid);

  if (markAsNew) {
    badges.push({
      id: 'newCarline',
      text: translations.markAsNew,
      type: 'encourage',
      variantContext,
    });
  }
  if (hasElectrical && fuelTypes.length === 1) {
    badges.push({
      id: 'electrical',
      text: variantContext === 'cargroup' ? '' : translations['fuelType.electrical'],
      icon: 'charging' as const,
      type: 'read-only',
      variantContext,
    });
  } else if (hasHybrid || (hasElectrical && hasPetrol)) {
    badges.push({ id: 'hybrid', text: translations['fuelType.hybrid'] });
  } else if (hasPetrol && hasDiesel) {
    badges.push({ id: 'petrolDiesel', text: translations['fuelType.petrolDiesel'] });
  } else if (hasPetrol) {
    badges.push({ id: 'petrol', text: translations['fuelType.petrol'] });
  } else if (hasDiesel) {
    badges.push({ id: 'diesel', text: translations['fuelType.diesel'] });
  }
  if (badges.length === 0) {
    return null;
  }
  return (
    <BadgesWrapper className={className}>
      {badges.map(({ id, text, type, icon }) => (
        <FrostyBadge key={id} text={text} type={type} icon={icon} variantContext={variantContext} />
      ))}
    </BadgesWrapper>
  );
};

const BadgesWrapper = styled.div`
  &.BadgeCarlineCard {
    display: flex;
    padding-left: ${({ theme }) => theme.spacing.fixed300};
    padding-right: ${({ theme }) => theme.spacing.fixed300};
    gap: var(--spacing-relative-2xs);
  }
`;
